import React, { useState, useEffect } from 'react';
import {
  Box, Typography, Button, TextField, Dialog, DialogTitle, DialogContent, DialogActions,
  IconButton, FormControl, InputLabel, Select, MenuItem,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { REASON_CODES } from '../utils/healingGate';

const FIELD_SX = {
  '& .MuiOutlinedInput-root': { color: '#e2e8f0', fontSize: '0.88rem', '& fieldset': { borderColor: 'rgba(255,255,255,0.1)' } },
  '& .MuiOutlinedInput-root:hover fieldset': { borderColor: 'rgba(255,255,255,0.2)' },
  '& .MuiOutlinedInput-root.Mui-focused fieldset': { borderColor: '#ef4444' },
};

/**
 * Reject dialog: required free-text reason plus an optional reason code.
 * onConfirm(reason, reasonCode) gets reasonCode === null when none is chosen.
 */
export default function RejectDialog({ open, onClose, onConfirm, actionLoading }) {
  const [reason, setReason] = useState('');
  const [code, setCode] = useState('');

  useEffect(() => {
    if (open) { setReason(''); setCode(''); }
  }, [open]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{ sx: { background: '#1e293b', color: '#e2e8f0', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 2 } }}
    >
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pb: 1 }}>
        <Typography sx={{ fontWeight: 600, fontSize: '1rem' }}>Reject Job</Typography>
        <IconButton size="small" onClick={onClose} sx={{ color: '#64748b' }}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Typography sx={{ color: '#64748b', mb: 2, fontSize: '0.85rem' }}>
          Provide a reason for rejecting this healing job.
        </Typography>
        <Box sx={{ mb: 2 }}>
          <FormControl fullWidth size="small" sx={FIELD_SX}>
            <InputLabel id="reject-code-label" sx={{ color: '#64748b' }}>Reason code (optional)</InputLabel>
            <Select
              labelId="reject-code-label"
              label="Reason code (optional)"
              value={code}
              displayEmpty
              onChange={(e) => setCode(e.target.value)}
              MenuProps={{ PaperProps: { sx: { background: '#1e293b', color: '#e2e8f0' } } }}
            >
              <MenuItem value=""><em>No code</em></MenuItem>
              {REASON_CODES.map((c) => (
                <MenuItem key={c.value} value={c.value}>{c.label}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
        <TextField
          autoFocus
          fullWidth
          multiline
          rows={3}
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          placeholder="Describe what's wrong with the repair..."
          sx={FIELD_SX}
        />
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} sx={{ color: '#64748b', textTransform: 'none' }}>Cancel</Button>
        <Button
          variant="contained"
          disabled={!reason.trim() || actionLoading}
          onClick={() => onConfirm(reason.trim(), code || null)}
          sx={{ background: '#ef4444', textTransform: 'none', fontWeight: 500, '&:hover': { background: '#dc2626' } }}
        >
          Reject
        </Button>
      </DialogActions>
    </Dialog>
  );
}
